module.exports = __webpack_public_path__ + "img/face mask.2e37f8a3.svg";